import * as Highcharts from 'highcharts';
import accessibility from 'highcharts/modules/accessibility';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';
import offlineExporting from 'highcharts/modules/offline-exporting';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import heatmap from 'highcharts/modules/heatmap';
import toast from 'react-hot-toast';
import { textLabels } from '../constants';

// PDF is deliberately absent: local PDF export would need jsPDF/svg2pdf, and the PDF report replaces it.
export const chartExportMenuItems = [
  'viewFullscreen',
  'printChart',
  'separator',
  'downloadPNG',
  'downloadJPEG',
  'downloadSVG',
  'separator',
  'downloadCSV',
  'downloadXLS',
];

const onLocalExportError: Highcharts.ExportingErrorCallbackFunction = (_options, error) => {
  console.error('Highcharts local export failed', error);
  toast.error(textLabels.chart_export_failed, { id: 'error:chart-export' });
};

// Registers the Highcharts modules once for the whole SPA (offline-exporting must come after exporting;
// heatmap is needed by the report charts drawn off screen, whichever section is open) and forbids any fallback to the public export server (export.highcharts.com): chart data stays in the browser.
export const setupHighcharts = () => {
  accessibility(Highcharts);
  exporting(Highcharts);
  exportData(Highcharts);
  offlineExporting(Highcharts);
  noDataToDisplay(Highcharts);
  heatmap(Highcharts);

  Highcharts.setOptions({
    exporting: {
      fallbackToExportServer: false,
      error: onLocalExportError,
      buttons: {
        contextButton: {
          menuItems: chartExportMenuItems,
        },
      },
    },
  });
};
